import React from "react";

const Alerts = ({ alertType, title, message }) => {
  return (
    <div className={`alert alert-${alertType}`}>
      {/* <button type="button" className="close" data-dismiss="alert" aria-hidden="true">×</button> */}
      {title && (
        <>
          <strong>{title}</strong>
          <hr className="message-inner-separator" />
        </>
      )}

      <p>{message}</p>
    </div>
  );
};

export default Alerts;
